import { useEffect } from "react";
import axiosInstance from "../config/axiosInstance";
import { useAppSetting } from "./appSettingContext";

const usePingServer = (frozen, setFrozen) => {
    const { appSettings, fetchBaseURL } = useAppSetting();

    useEffect(() => {
        if (!frozen) return;

        const interval = setInterval(async () => {
            try {
                // Always fetch base URL before ping
                const updatedBaseURL = await fetchBaseURL();
                if (!updatedBaseURL) return;

                const res = await axiosInstance.post(`${updatedBaseURL}/ping`, {
                    timeout: 5000,
                });

                if (res.status === 200) {
                    setFrozen(false);
                    clearInterval(interval);
                }
            } catch (err) {
                // still down, continue polling
            }
        }, 5000);

        return () => clearInterval(interval);
    }, [frozen, setFrozen, fetchBaseURL]);
};

export default usePingServer;
